import React from 'react'
import { motion } from 'framer-motion'
import Bg from '../../Assets/images/inn1.png'
import Bgs from '../../Assets/images/inn2.png'
import Star from '../../Assets/images/star.svg'
import Constant from '../../Constant'
import Button from '../SelectValue/Button'

function TopSec() {
  return (
    <div className="body-bg">
      <div className="pt-[140px] sm:pt-[177px] grid sm:grid-cols-3 gap-4">
        
        <motion.div
          className="sm:col-span-2 mb-10 px-6 sm:px-24"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true, amount: 0.3 }}
        >
          <div>
            <motion.div
              initial={{ opacity: 0, x: -40 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7, ease: "easeOut" }}
              viewport={{ once: true }}
            >
              <p className="inline-block bg-white p-3 text-[12px] font-[500] rounded-[32px] text-primary-color mb-4">
                <img src={Star} alt="Start" className="inline" /> on Halal Wealth
              </p>
            </motion.div>

            <motion.h1
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
              viewport={{ once: true }}
              className="text-[24px] mb-6 font-[24px] text-text-color1 sm:text-[48px]"
            >
              Invest with Integrity.
              <span className={Constant.linearColor}> Profit with Barakah </span>
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4, ease: "easeOut" }}
              viewport={{ once: true }}
              className="text-[14px] mb-10 font-[500] text-text-color1 sm:text-[20px]"
            >
              Turn your savings into halal, high-impact investments - designed to grow your wealth while fueling ethical businesses.
            </motion.p>

            <motion.div
              className="flex flex-col sm:flex-row justify-right gap-4 mb-8"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.6, ease: "easeOut" }}
              viewport={{ once: true }}
            >
              <Button name="Discover Investment Pods" />
              {/* <Button name="See Performance Data" /> */}
            </motion.div>
          </div>
        </motion.div>

        <motion.div
          className="px-10 sm:pt-20"
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.3, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <img src={Bg} alt="home" className="hidden sm:block" />
          <img src={Bgs} alt="home" className="sm:hidden block" />
        </motion.div>
      </div>
    </div>
  )
}

export default TopSec
